import React, { useMemo } from 'react';
import { Typography } from 'antd';

import { TextProps } from 'antd/lib/typography/Text';
import { truncateString } from '../../../util';
import { ContactId } from '../../../models/Types';
import { makePrioStyles } from '../../../theme/utils';
import useContactsContext from '../hooks/useContactsProvider';

interface ContactTextProps extends TextProps {
  contactId: ContactId;
  addLineBreak?: boolean;
  maxChars?: number;
  plain?: boolean;
  fallback?: React.ReactElement<any>;
  hasTitle?: boolean;
}

const useStyles = makePrioStyles((theme) => ({
  root: {},
}));

export const ContactText: React.FC<ContactTextProps> = (props) => {
  const {
    contactId,
    addLineBreak,
    maxChars,
    plain,
    fallback,
    hasTitle,
    ...rest
  } = props;
  const classes = useStyles();

  const { getContactById } = useContactsContext();
  const contact = useMemo(() => {
    return getContactById(contactId);
  }, [contactId, getContactById]);

  if (!contact) {
    if (fallback) return fallback;
    return null;
  }

  const text = `${contact.firstName} ${contact.lastName}`;
  const finalText = maxChars ? truncateString(text, maxChars) : text;

  if (plain) {
    return (
      <>
        {finalText}
        {addLineBreak && <br />}
      </>
    );
  }

  return (
    <Typography.Text
      className={classes.root}
      title={hasTitle ? text : undefined}
      {...rest}
      ellipsis
    >
      {finalText}
      {addLineBreak && <br />}
    </Typography.Text>
  );
};

export default ContactText;
